import React, {forwardRef} from 'react'
import {SvgIcon, SvgIconProps} from '@material-ui/core'

export function SvgPathIcon(path){
    return forwardRef<any, SvgIconProps>((props, ref) =>
        <SvgIcon ref={ref} {...props}>
            <path d={path}/>
        </SvgIcon>
    )
}